import { FC } from 'react';
import { DialogContent as MuiDialogContent, DialogContentProps } from '@mui/material';

export const DialogContent: FC<DialogContentProps> = ({ children, ...props }) => {
  return <MuiDialogContent {...props}>{children}</MuiDialogContent>;
};
